__turbopack_context__.v({
  "heading": "qkxLaq_heading",
});
